import { computed } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { FormFields, ListField } from "@/types";

export const systemName = "paypal";

export const listField: ListField = { value: systemName, text: $t("PayPal") };

export const formFields = computed<FormFields>(() => [
  {
    name: "account",
    label: $t("PayPal email address"),
    rules: ["required"],
    validationMode: "aggressive",
  },
]);
